// 🎯 AAAS Donation API - Configuration corrigée
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://donner.aaas.fr';

const donationAPI = {
  async createCheckoutSession(amount, customerData, isMonthly = false) {
    const url = `${API_BASE_URL}/api/create-checkout-session`;
    console.log('🛒 Creating AAAS Checkout session:', url);
    
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          amount: amount,
          currency: 'eur',
          customerData: customerData,
          isMonthly: isMonthly,
          successUrl: `${window.location.origin}/?payment=success&session_id={CHECKOUT_SESSION_ID}`,
          cancelUrl: `${window.location.origin}/?payment=cancelled`
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `HTTP ${response.status}: Checkout session creation failed`);
      }

      const result = await response.json();
      console.log('✅ Checkout session created successfully');
      return result;

    } catch (error) {
      console.error('❌ Checkout API Error:', error.message);
      throw error;
    }
  },

  async getCheckoutSession(sessionId) {
    const url = `${API_BASE_URL}/session-status`;
    console.log('📊 Getting checkout session status:', sessionId);
    
    try {
      const response = await fetch(`${url}?session_id=${sessionId}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `HTTP ${response.status}: Session retrieval failed`);
      }

      const result = await response.json();
      console.log('✅ Session status retrieved');
      return result;

    } catch (error) {
      console.error('❌ Session API Error:', error.message);
      throw error;
    }
  },

  async createCardPaymentIntent(amount, customerData, isMonthly = false) {
    const url = `${API_BASE_URL}/api/create-checkout-session`;
    console.log('🌐 Calling backend:', url);
    
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          amount: amount,
          currency: 'eur',
          customerData: customerData,
          isMonthly: isMonthly,
          paymentMethodType: 'card'
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `HTTP ${response.status}: Payment request failed`);
      }

      const result = await response.json();
      console.log('✅ Payment Intent created successfully');
      return result;

    } catch (error) {
      console.error('❌ API Error:', error.message);
      throw error;
    }
  }
};

export const APIErrorHandler = {
  getErrorMessage: (error, lang = 'fr') => {
    const messages = {
      fr: {
        fetch: 'Impossible de contacter le serveur. Vérifiez votre connexion.',
        server: 'Erreur serveur. Veuillez réessayer.',
        default: 'Une erreur inconnue s\'est produite.'
      },
      en: {
        fetch: 'Unable to contact server. Please check your connection.',
        server: 'Server error. Please try again.',
        default: 'An unknown error occurred.'
      },
      es: {
        fetch: 'No se puede contactar al servidor. Verifique su conexión.',
        server: 'Error del servidor. Inténtelo de nuevo.',
        default: 'Ocurrió un error desconocido.'
      }
    };

    const msg = messages[lang] || messages.fr;

    if (error.message.includes('Failed to fetch')) {
      return msg.fetch;
    }
    if (error.message.includes('HTTP 500') || error.message.includes('HTTP 404')) {
      return msg.server;
    }
    return error.message || msg.default;
  },
  
  logError: (error, context = {}) => {
    console.error('🚨 AAAS API Error:', error.message, context);
  }
};

export { donationAPI }; 
export default donationAPI;